import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { AppLayout } from "./layouts/AppLayout";
import { Skeleton } from "./components/common/Skeleton";
import { ScrollToTop } from "./components/common/ScrollToTop";

const HomePage = lazy(() =>
  import("./pages/HomePage").then((module) => ({ default: module.HomePage })),
);
const AboutPage = lazy(() =>
  import("./pages/AboutPage").then((module) => ({ default: module.AboutPage })),
);
const ContactPage = lazy(() =>
  import("./pages/ContactPage").then((module) => ({
    default: module.ContactPage,
  })),
);
const ServicesListingPage = lazy(() =>
  import("./pages/OfferingListingPage").then((module) => ({
    default: module.ServicesListingPage,
  })),
);
const SolutionsListingPage = lazy(() =>
  import("./pages/OfferingListingPage").then((module) => ({
    default: module.SolutionsListingPage,
  })),
);
const OfferingPage = lazy(() =>
  import("./pages/OfferingPage").then((module) => ({
    default: module.OfferingPage,
  })),
);
const PortfolioPage = lazy(() =>
  import("./pages/PortfolioPage").then((module) => ({
    default: module.PortfolioPage,
  })),
);
const PortfolioDetailPage = lazy(() =>
  import("./pages/PortfolioPage").then((module) => ({
    default: module.PortfolioDetailPage,
  })),
);
const BlogPage = lazy(() =>
  import("./pages/BlogPage").then((module) => ({ default: module.BlogPage })),
);
const BlogDetailPage = lazy(() =>
  import("./pages/BlogPage").then((module) => ({
    default: module.BlogDetailPage,
  })),
);
const NotFoundPage = lazy(() =>
  import("./pages/NotFoundPage").then((module) => ({
    default: module.NotFoundPage,
  })),
);

export function App() {
  return (
    <Suspense fallback={<RouteLoader />}>
      <ScrollToTop />

      <Routes>
        <Route element={<AppLayout />}>
          <Route index element={<HomePage />} />
          <Route path="services" element={<ServicesListingPage />} />
          {/* <Route path="services/:slug" element={<ServicePage />} /> */}
          <Route path="solutions" element={<SolutionsListingPage />} />
          {/* <Route path="solutions/:slug" element={<SolutionPage />} /> */}
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="portfolio/:slug" element={<PortfolioDetailPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:slug" element={<BlogDetailPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path=":slug" element={<OfferingPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

function RouteLoader() {
  return (
    <div className="min-h-screen bg-background px-4 pt-32">
      <div className="mx-auto max-w-7xl">
        <Skeleton className="h-12 max-w-xl" />
        <Skeleton className="mt-6 h-64 w-full" />
      </div>
    </div>
  );
}
